.overlay {
  display: flex;
  position: absolute;
  align-items: center;
  justify-content: center;
  inset: 0;
  padding: 16px;
  background: rgba(0, 0, 0, 0.5);
  z-index: var(--cxy-z-index-control-highest);
}

.modal {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  max-width: 320px;
  padding: 20px;
  border-radius: 8px;
  background: var(--ogm-white);
  box-shadow:
    0 4px 10px 0 rgba(0, 0, 0, 0.16),
    0 4px 10px 0 rgba(0, 0, 0, 0.23);
  text-align: center;
}

.title {
  margin: 0;
  color: var(--cxy-color-content-default);
  font-family: var(--ogm-font-family-1);
  font-size: 18px;
  font-weight: 700;
}

.message {
  margin: 0;
  color: var(--cxy-color-content-default);
  font-family: var(--ogm-font-family-2);
  font-size: 14px;
  line-height: 1.4;
}

.reference {
  margin: 0;
  color: var(--cxy-color-content-dark);
  font-family: var(--ogm-font-family-2);
  font-size: 12px;
}

.code {
  font-family: monospace;
  font-weight: 700;
  letter-spacing: 0.05em;
}

.dismiss {
  margin-top: 4px;
  padding: 10px 16px;
  border: none;
  border-radius: 4px;
  background: var(--cxy-color-brand);
  color: var(--cxy-color-white);
  font-family: var(--ogm-font-family-1);
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}

.dismiss:focus-visible {
  outline: 2px solid var(--cxy-color-content-default);
  outline-offset: 2px;
}
